export default __webpack_public_path__ + "static/media/B5.2be33784.mp3";